import { render, staticRenderFns } from "./ModalMoverDocumento.vue?vue&type=template&id=66dfe2b6&scoped=true"
import script from "./ModalMoverDocumento.vue?vue&type=script&lang=js"
export * from "./ModalMoverDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dfe2b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66dfe2b6')) {
      api.createRecord('66dfe2b6', component.options)
    } else {
      api.reload('66dfe2b6', component.options)
    }
    module.hot.accept("./ModalMoverDocumento.vue?vue&type=template&id=66dfe2b6&scoped=true", function () {
      api.rerender('66dfe2b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documento/ModalMoverDocumento.vue"
export default component.exports